// extracted by mini-css-extract-plugin
export default {"econDeg":"_Education_econDeg__HxzoB","title":"_Education_title__UbSug"};